import { Box, BoxProps, rem } from '@vimeo/bokeh';
import { ColdStorageVideoLockedIcon } from '@vimeo/content-cards';

export interface ColdStorageThumbnailLockOverlayProps {
  iconSize?: string | number;
  iconPadding?: string | number;
  /** Should match the underlying thumbnail's radius so the dimmed corners align. */
  borderRadius?: BoxProps['borderRadius'];
}

/**
 * Full-thumbnail cold-storage lock overlay (dimmed backdrop + rounded-square lock badge).
 * Matches library / team-library locked video thumbnails.
 */

export const ColdStorageThumbnailLockOverlay = ({
  iconSize = rem(32),
  iconPadding = rem(8),
  borderRadius = 'md',
}: ColdStorageThumbnailLockOverlayProps) => {
  return (
    <Box
      position="absolute"
      inset={0}
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius={borderRadius}
      overflow="hidden"
      zIndex={1}
      background="rgba(0, 0, 0, 0.64)"
    >
      <Box
        display="flex"
        padding={iconPadding}
        justifyContent="center"
        alignItems="center"
        borderRadius={rem(8)}
        background="rgba(104, 114, 124, 0.64)"
        backdropFilter="blur(1px)"
        position="relative"
        zIndex={1}
      >
        <ColdStorageVideoLockedIcon color="white" boxSize={iconSize} />
      </Box>
    </Box>
  );
};
